import { Link } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useTopDeudores } from '@/hooks/useReportes'
import { rutaFichaCliente } from '@/lib/ruta-cliente'
import { formatCurrency } from '@/lib/utils'

export const LIMITE_TOP_DEUDORES = 10

/** Los 10 clientes activos con mayor saldo al día de hoy, cada uno con link a su cuenta corriente. */
export function TopDeudores() {
  const { data, isLoading, isError } = useTopDeudores(LIMITE_TOP_DEUDORES)

  return (
    <Card role="region" aria-labelledby="top-deudores-titulo">
      <CardHeader className="pb-2">
        <CardTitle id="top-deudores-titulo" className="text-sm font-medium text-muted-foreground">
          Mayores deudores
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isError ? (
          <p className="text-sm text-destructive">No se pudo cargar el dato.</p>
        ) : isLoading || !data ? (
          <Skeleton className="h-48 w-full" />
        ) : data.deudores.length === 0 ? (
          <p className="text-sm text-muted-foreground">No hay clientes activos con deuda.</p>
        ) : (
          <ol className="divide-y">
            {data.deudores.map((d) => (
              <li key={d.id} className="flex items-center justify-between gap-3 py-1.5 text-sm">
                <Link
                  to={d.id ? rutaFichaCliente(d.id, 'cuenta') : '/clientes'}
                  className="truncate hover:underline"
                >
                  {d.nombre}
                </Link>
                <span className="whitespace-nowrap font-medium text-red-600">{formatCurrency(d.saldo ?? 0)}</span>
              </li>
            ))}
          </ol>
        )}
      </CardContent>
    </Card>
  )
}
